/** Mutually exclusive overall-progress bands (aligned with Progress Dashboard row badges). */
export const PROGRESS_BAND_THRESHOLDS = {
  onTrack: 80,
  goodProgress: 60,
  needsSupport: 40,
};

export function classifyOverallProgressBand(percentageComplete, hasProgressData) {
  if (!hasProgressData) return 'noData';
  const pct = Number(percentageComplete) || 0;
  if (pct >= PROGRESS_BAND_THRESHOLDS.onTrack) return 'onTrack';
  if (pct >= PROGRESS_BAND_THRESHOLDS.goodProgress) return 'goodProgress';
  if (pct >= PROGRESS_BAND_THRESHOLDS.needsSupport) return 'needsSupport';
  return 'requiresAttention';
}

export function countProgressBands(students) {
  const counts = {
    onTrack: 0,
    goodProgress: 0,
    needsSupport: 0,
    requiresAttention: 0,
    noData: 0,
  };
  for (const student of students) {
    const hasProgress = Boolean(student.progress);
    const pct = student.progress?.overallProgress?.percentageComplete ?? 0;
    counts[classifyOverallProgressBand(pct, hasProgress)] += 1;
  }
  return counts;
}

/** Summary row: on track (incl. good progress) | needs support | requires attention | no data */
export function progressBandSummary(counts) {
  return {
    onTrackOrGood: counts.onTrack + counts.goodProgress,
    onTrackOnly: counts.onTrack,
    goodProgressOnly: counts.goodProgress,
    needsSupport: counts.needsSupport,
    requiresAttention: counts.requiresAttention,
    noData: counts.noData,
    total:
      counts.onTrack +
      counts.goodProgress +
      counts.needsSupport +
      counts.requiresAttention +
      counts.noData,
  };
}
